import callAPiBase from './base';

const tripsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/tripList',
      method: 'GET',
      useToken: true,
      title: 'Trip - Get List',
      params,
    }),
  pdfDownload: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripReportPdf',
      method: 'POST',
      useToken: true,
      title: 'Trip PDF - Download',
      data,
      responseType: 'blob',
    }),
  addPayment: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripAddPayment',
      method: 'POST',
      useToken: true,
      title: 'Trip Payment - AddPayment',
      data,
    }),
  addApproval: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripAddApproval',
      method: 'POST',
      useToken: true,
      title: 'Trip Approval - AddApproval',
      data,
    }),
  addApprovalAll: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripAddApprovalAll',
      method: 'POST',
      useToken: true,
      title: 'Trip Approval All - AddApprovalAll',
      data,
    }),
  reportHtml: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripReportHtml',
      method: 'POST',
      useToken: true,
      title: 'Trip Report Html - tripReportHtml',
      data,
    }),
  tripReport: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripReport',
      method: 'POST',
      useToken: true,
      title: 'Trip Report - tripReport',
      data,
    }),

  tripUpdateControl: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripUpdateControl',
      method: 'POST',
      useToken: true,
      title: 'Trip Report - tripUpdateControl',
      data,
    }),
  getControlSettings: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/tripControlSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'Trip - Get Trip Control Settings',
      params,
    }),
  tripControlSettingsUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripControlSettingsUpdate',
      method: 'POST',
      useToken: true,
      title: 'Trip Report - tripControlSettingsUpdate',
      data,
    }),
  monitoringKmSettingsGet: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/monitoringKmSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'Trip - Get Monitoring Settings',
      params,
    }),
  monitoringKmSettingsUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/monitoringKmSettingsUpdate',
      method: 'POST',
      useToken: true,
      title: 'Trip Report - monitoringKmSettingsUpdate',
      data,
    }),
  tripAskMissingEntries: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tripAskMissingEntries',
      method: 'POST',
      useToken: true,
      title: 'Trip Report - tripAskMissingEntries',
      data,
    }),
};

export { tripsApi };
export default tripsApi;
